module.exports = __webpack_public_path__ + "static/media/Spencer-Molnar.4eb80930.png";